import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

//components
import SuperDawa from './components/SuperDawaAddress.vue';
import SelectList from './components/SelectList.vue';
import ModelOverview from './components/ModelOverview.vue';
import ModelDetails from './components/ModelDetails.vue';
import Gallery from './components/Gallery.vue';
import StockListModelOverview from './components/StockListModelOverview.vue';
import SimpleGallery from './components/SimpleGallery.vue';
import ScriptBlock from './components/ScriptBlock.vue';

//Filter registration
import { installFilters } from './filters/formattingFilters.js';

// Create router instance
const router = createRouter({
    history: createWebHistory(),
    routes: []
});

// Create Vue app
const app = createApp({});

// Install filters
installFilters(app);

// Register global components
app.component('super-dawa-address', SuperDawa);
app.component('select-list', SelectList);
app.component('model-overview', ModelOverview);
app.component('model-details', ModelDetails);
app.component('gallery', Gallery);
app.component('stock-list-model-overview', StockListModelOverview);
app.component('simple-gallery', SimpleGallery);
app.component('script-block', ScriptBlock);

// Use router
app.use(router);

// Mount the app
app.mount('#vue-application-sdf');